// Nome e data de nascimento — só aparece quando o perfil ainda não tem NOME.
//
// A validação e a conversão DD/MM/AAAA → AAAA-MM-DD são as MESMAS de antes:
// é o `DATA_NASC` canônico que o `generateCompletePlan` usa para a idade, e
// mexer no formato quebraria o cálculo calado. O que mudou é a casca — os
// três `FloatingLabel` do bootstrap saíram.

import React, { useEffect, useState } from "react";

import { Campo } from "../widgets/Widgets.jsx";
import s from "./StepName.module.scss";

const soLetras = (v) => v.replace(/[^a-zA-ZÀ-ÿ\s]/g, "");

/** Máscara DD/MM/AAAA sobre os dígitos digitados. */
function mascaraData(valor) {
  let v = valor.replace(/\D/g, "").slice(0, 8);
  if (v.length > 4) v = v.replace(/^(\d{2})(\d{2})(\d)/, "$1/$2/$3");
  else if (v.length > 2) v = v.replace(/^(\d{2})(\d)/, "$1/$2");
  return v;
}

/** Data que EXISTE, não só data com o formato certo (31/02 não passa). */
function dataValida(texto) {
  if (!/^(\d{2})\/(\d{2})\/(\d{4})$/.test(texto)) return false;
  const [dia, mes, ano] = texto.split("/").map(Number);
  const d = new Date(ano, mes - 1, dia);
  return (
    d.getDate() === dia
    && d.getMonth() === mes - 1
    && d.getFullYear() === ano
    && ano > 1900
    && d <= new Date()
  );
}

const StepName = ({ setCanProceed, setStepData }) => {
  const [nome, setNome] = useState("");
  const [sobrenome, setSobrenome] = useState("");
  const [nascimento, setNascimento] = useState("");

  useEffect(() => {
    const valido =
      nome.trim().length >= 2
      && sobrenome.trim().length >= 2
      && dataValida(nascimento);

    setCanProceed(valido);

    if (!valido) {
      setStepData(null);
      return;
    }

    const [dia, mes, ano] = nascimento.split("/");
    setStepData({
      NOME: nome.trim(),
      SOBRENOME: sobrenome.trim(),
      DATA_NASC: `${ano}-${mes}-${dia}`,
    });
  }, [nome, sobrenome, nascimento, setCanProceed, setStepData]);

  return (
    <div className={s.bloco}>
      <label className={s.campo}>
        <span className={s.rotulo}>PRIMEIRO NOME</span>
        <Campo
          valor={nome}
          onChange={(v) => setNome(soLetras(v))}
          placeholder="Seu nome"
          autoComplete="given-name"
        />
      </label>

      <label className={s.campo}>
        <span className={s.rotulo}>SOBRENOME</span>
        <Campo
          valor={sobrenome}
          onChange={(v) => setSobrenome(soLetras(v))}
          placeholder="Seu sobrenome"
          autoComplete="family-name"
        />
      </label>

      <label className={s.campo}>
        <span className={s.rotulo}>DATA DE NASCIMENTO</span>
        <Campo
          valor={nascimento}
          onChange={(v) => setNascimento(mascaraData(v))}
          placeholder="DD/MM/AAAA"
          // `tel` e não `number`: o teclado numérico sem as setas de spinner,
          // e a máscara com barras sobrevive.
          type="tel"
          inputMode="numeric"
          maxLength={10}
        />
      </label>
    </div>
  );
};

export default StepName;
